import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import i18next from 'i18next';

import { toDisplayDecimal } from '../../../utils';
import styles from '../../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    divList: {
        paddingTop: '5px',
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    }
}));

export default function VacationBankSummary(props) {

    const classes = useStyles();
    const [dataBank, setDataBank] = React.useState(null);
    const { data } = props;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setDataBank(data);
    }

    return (
        <div id="divVacationBankSummary" className={styles.rootPayBank}>
            <div className={styles.konekCard}>
                <div className={classes.divList}>
                    {dataBank != null && dataBank.map((obj, index) =>
                        <React.Fragment key={index}>
                            <ListItem key={index} className="listItem">
                                <ListItemText primary={
                                    <React.Fragment>
                                        <div>                                            
                                            <span className={classes.spanLabel}>{`${i18next.t(obj.accUnit !== null ? "bankBalance:form.accruedUnits" : "bankBalance:form.accruedAmount")}${i18next.t('common:labelSeparator')}`}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.accumulatedUnit))}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{`${i18next.t(obj.accUnit !== null ? "bankBalance:form.takenUnits" : "bankBalance:form.takenAmount")}${i18next.t('common:labelSeparator')}`}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.takenUnit))}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{`${i18next.t(obj.accUnit !== null ? "bankBalance:form.bankBalance" : "bankBalance:form.balanceAmount")}${i18next.t('common:labelSeparator')}`}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.balanceUnit))}</span>
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}